class Hero {
  constructor() {
    this.init = this.init.bind(this);
    this.timer = this.timer.bind(this);
  }

  init($hero) {
    // set initial state
    this.state = {
      activeSlide: -1,
      lastTime: 0,
      // progress: 0,
      slideTimeout: 6000,
      isPlaying: false,
    };

    // cache elements
    this.$slides = $hero.querySelectorAll('.js--hero__slide');
    this.$bulletsWrap = $hero.querySelector('.js--hero__bullets');
    this.$bullets = $hero.querySelectorAll('.js--hero__bullet');
    this.$arrowLeft = $hero.querySelector('.js--hero__arrow-left');
    this.$arrowRight = $hero.querySelector('.js--hero__arrow-right');
    this.$sliderHitArea = $hero.querySelector('.js--hero__slider');

    if (this.$slides.length > 1) {
      // if multiple slides, make a slider
      this.makeSlider();
    } else {
      // if single slide, set the first one visible
      this.$slides[0].classList.add('is-active');
    }

    // set CSS know JS is executed
    $hero.classList.add('is-loaded');
  }

  makeSlider() {
    // unhide the bullets
    this.$bulletsWrap.removeAttribute('hidden');

    for (let i = 0; i < this.$bullets.length; i += 1) {
      const $bullet = this.$bullets[i];
      $bullet.addEventListener('click', e => {
        this.setActiveSlide(i);
        e.preventDefault();
      });
    }

    // unhide the arrows
    this.$arrowLeft.removeAttribute('hidden');
    this.$arrowRight.removeAttribute('hidden');

    // go to previous slide
    this.$arrowLeft.addEventListener('click', e => {
      this.state.activeSlide = this.state.activeSlide === 0 ? this.state.activeSlide = this.$slides.length - 1 : this.state.activeSlide -= 1;
      this.setActiveSlide(this.state.activeSlide);
    });

    // go to next slide
    this.$arrowRight.addEventListener('click', e => {
      this.state.activeSlide = this.state.activeSlide > this.$slides.length - 2 ? 0 : this.state.activeSlide += 1;
      this.setActiveSlide(this.state.activeSlide);
    });

    // on mouseover, pause the animation
    this.$sliderHitArea.addEventListener('mouseover', () => {
      this.state.isPlaying = false;
    });

    // on mouseout, reset 'lasttime', resume play
    this.$sliderHitArea.addEventListener('mouseout', () => {
      this.state.lastTime = (new Date()).getTime();
      this.state.isPlaying = true;
      this.timer();
    });

    // start the sliding animation
    this.state.isPlaying = true;
    this.timer();
  }

  timer() {
    // fire this function continuously
    if (this.state.isPlaying) {
      window.requestAnimationFrame(this.timer);
    }

    const currentTime = (new Date()).getTime();

    // this.state.progress = currentTime - this.state.lastTime;

    // if timeout is exceeded
    if (currentTime - this.state.lastTime > this.state.slideTimeout) {
      // reset the timer
      this.state.lastTime = currentTime;
      // set active slide offset
      this.state.activeSlide = this.state.activeSlide > this.$slides.length - 2 ? 0 : this.state.activeSlide += 1;

      this.setActiveSlide(this.state.activeSlide);
    }
  }

  setActiveSlide(offset) {
    // reset the timer
    this.state.lastTime = (new Date()).getTime();

    // get and set new timeout from active slide
    this.state.slideTimeout = this.$slides[offset].dataset.slideTimeout;

    // set all slides and bullet inactive
    [...this.$slides].forEach($slide => {
      $slide.classList.remove('is-active');
    });

    [...this.$bullets].forEach($bullet => {
      $bullet.classList.remove('is-active');
    });

    // set active slide and bullet active
    this.$slides[offset].classList.add('is-active');
    this.$bullets[offset].classList.add('is-active');
  }
}

[...document.querySelectorAll('.js--hero')].forEach($hero => {
  const inst = new Hero();
  inst.init($hero);
});
